var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-confirmation" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "info-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            title: _vm.texts.title,
          },
          on: {
            close: function ($event) {
              _vm.active = false
            },
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            { staticClass: "m-confirmation-text" },
            [
              _vm.texts.text
                ? _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.texts.text) },
                  })
                : _vm._e(),
              _vm._t("default"),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "m-confirmation-buttons" },
            [
              _c("c-button", {
                attrs: { size: "large", label: _vm.texts.reset || "Отменить" },
                on: { click: _vm.close },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }